import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 6l-11 0","key":"svg-0"}],["path",{"d":"M20 12l-7 0","key":"svg-1"}],["path",{"d":"M20 18l-11 0","key":"svg-2"}],["path",{"d":"M4 8l4 4l-4 4","key":"svg-3"}]]

const IconIndentIncrease = createReactComponent('outline', 'indent-increase', 'IndentIncrease', __iconNode);

export default IconIndentIncrease;